export const PLATFORM_HAS_COMMAND_KEY =
    navigator.platform.startsWith("Mac") || navigator.platform === "iPhone" || navigator.userAgent.includes("Mac")
